import { render, staticRenderFns } from "./MemberTempPassword.vue?vue&type=template&id=19d6db80&"
import script from "./MemberTempPassword.vue?vue&type=script&lang=ts&"
export * from "./MemberTempPassword.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports